/**
 * Initial details handoff.
 *
 * The standalone company page already loads GET_PROFILER_DETAILS for its own
 * header merge (searchId and direct-link branches). It hands that response to
 * CompanyDetails as `initialDetails: { companyId, data }` so the component does
 * not request the same details again on mount.
 *
 * The handoff is used only when it is what CompanyDetails would have loaded
 * itself: the same company, a user who may see details, and a plain request.
 * In a feedback project CompanyDetails adds `sharedProjectId`, so a host's plain
 * response is not equivalent there. In every other case CompanyDetails loads
 * details itself, as it did before.
 *
 * @param {{ companyId: string, data: Object } | null | undefined} initialDetails
 * @param {Object} options
 * @param {string} options.companyId - id of the company CompanyDetails is showing
 * @param {boolean} options.canViewDetails - profilerAccessStore.canViewProfilerDetails(project)
 * @param {boolean} [options.isFromFeedbackProject=false] - CompanyDetails' own request would carry sharedProjectId
 * @returns {Object | null} the details response to apply, or null to load it
 */
export const getUsableInitialDetails = (
  initialDetails,
  { companyId, canViewDetails, isFromFeedbackProject = false }
) => {
  if (!initialDetails?.data || !canViewDetails || isFromFeedbackProject) return null;
  if (companyId == null || initialDetails.companyId !== companyId) return null;
  return initialDetails.data;
};
